module.exports = __webpack_public_path__ + "static/media/ipnos-hero.034be556.png";